<template>
    <div class="oa-workplace">
        <!-- 第一大行：三列布局，底部对齐 -->
        <div class="row-top">
            <!-- 左侧：事项办理 + 公司公告 -->
            <div class="col-todo">
                <TodoCenter />
                <CompanyNotice />
            </div>
            <!-- 中间：公司新闻 -->
            <div class="col-news">
                <CompanyNews />
            </div>
            <!-- 右侧：工作日历 + 便捷功能 -->
            <div class="col-right">
                <WorkCalendar />
                <QuickFunctions />
            </div>
        </div>

        <!-- 第二大行：起草中心 | 外部网站链接，左右各50% -->
        <div class="row-bottom">
            <div class="col-bottom-left">
                <OuterLinks />
            </div>
            <div class="col-bottom-right">
                <ApprovalDraft />
            </div>
        </div>
    </div>
</template>

<script>
import WorkCalendar from './components-desk/WorkCalendar.vue'
import ApprovalDraft from './components-desk/ApprovalDraft.vue'
import TodoCenter from './components-desk/TodoCenter.vue'
import QuickFunctions from './components-desk/QuickFunctions.vue'
import CompanyNews from './components-desk/CompanyNews.vue'
import CompanyNotice from './components-desk/CompanyNotice.vue'
import OuterLinks from './components-desk/OuterLinks.vue'

export default {
    name: 'OaWorkplace',
    components: {
        WorkCalendar,
        ApprovalDraft,
        TodoCenter,
        QuickFunctions,
        CompanyNews,
        CompanyNotice,
        OuterLinks
    }
}
</script>

<style scoped>
.oa-workplace {
    padding: 12px;
    background: #f6f8fc;
    min-height: 100vh;
    margin-top: -55px;
}

/* 两行共用相同的三列网格轨道，保证上下行列边界严格对齐 */
.row-top {
    display: grid;
    grid-template-columns: 33fr 40fr 27fr;
    gap: 12px;
    margin-bottom: 12px;
    align-items: stretch;
}
.row-bottom {
    display: grid;
    grid-template-columns: 33fr 40fr 27fr;
    gap: 12px;
    align-items: stretch;
}

/* 左侧列：事项办理 + 公司公告 垂直堆叠（第1列） */
.col-todo {
    grid-column: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}
/* 中间列：公司新闻 撑满高度（第2列） */
.col-news {
    grid-column: 2;
    display: flex;
    flex-direction: column;
    min-width: 0;
}
/* 右侧列：工作日历 + 便捷功能 垂直堆叠（第3列） */
.col-right {
    grid-column: 3;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}

/* 底部行左：外部网站链接（第1列，与上方事项办理/公司公告右边缘对齐） */
.col-bottom-left{
    grid-column: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}
/* 底部行右：起草中心（跨第2-3列，左边缘与上方新闻对齐） */
.col-bottom-right{
    grid-column: 2 / 4;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}
/* 底部行：外部网站链接 与 起草中心 撑满列高，底部对齐 */
.col-bottom-left :deep(.panel-card),
.col-bottom-right :deep(.panel-card) {
    flex: 1;
    height: 100%;
}
.col-half {
    width: 50%;
}

/* === 组件高度控制：让底部对齐 === */

/* 左侧：TodoCenter 占满剩余高度，CompanyNotice 固定底部 */
.col-todo :deep(.approval-card) {
    flex: 1;
    min-height: 0;
    height: auto !important;
}
.col-todo :deep(.panel-card) {
    flex: none;
    height: auto !important;
}

/* 中间：CompanyNews 撑满整列 */
.col-news :deep(.panel-card) {
    height: 100%;
    flex: 1;
}

/* 右侧：WorkCalendar 固定高度，QuickFunctions 占满剩余 */
.col-right :deep(.approval-card) {
    flex: none;
    height: auto !important;
}
.col-right :deep(.panel-card) {
    flex: 1;
    height: auto !important;
}

/* ant卡片通用 */
.oa-workplace :deep(.ant-card) {
    margin-bottom: 0 !important;
}
</style>
